import { GRID_SIZE } from '../config/constants'
import { StaticEntity } from './static-entity'

export const Exit = ({ x, y, width = GRID_SIZE, height = GRID_SIZE, config = {} }) =>
  <StaticEntity x={x} y={y} width={width} height={height} entityType="exit" config={config} />
